// libs
import styled from "styled-components";
// theme
import { typography, colors } from "src/theme";
// const
import device from "src/constants/media";

export const Web = styled.div`
  display: none;

  @media ${device.tablet} {
    display: block;
  }
`;

export const Mobile = styled.div`
  @media ${device.tablet} {
    display: none;
  }
`;

export const GridWrapper = styled.div`
  //height: 100%;
  padding: 25px 25px 164px;

  @media ${device.tablet} {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 50px;
    padding: 25px 25px 126px;
  } ;
`;
export const FiltersWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 86px;
  margin-top: 40px;

  @media ${device.tablet} {
    width: 125px;
    margin-top: 48px;
  }
`;

export const TopServicesContainer = styled.div`
  display: flex;
`;

export const BadgeContainer = styled.div`
  position: relative;
`;

export const MapWrapper = styled(Web)`
  position: sticky;
  top: 15px;

  width: 100%;
  max-height: 90vh;

  @media ${device.tablet} {
    height: 400px;
  }

  @media ${device.laptop} {
    height: 530px;
  }

  @media ${device.laptopL} {
    height: 760px;
  }
`;

export const TextPagination = styled.p`
  padding-left: 3px;
  font-family: ${typography.fontFamily};
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: ${colors.grey};
  margin-top: 16px;
`;

export const ClinicCardWebWrapper = styled(Web)`
  @media ${device.tablet} {
    margin: 32px 0;
  }
`;

export const ClinicCardMobileWrapper = styled(Mobile)`
  margin: 20px 0;
`;

// empty search
export const EmptyWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  flex-grow: 1;
  height: 100%;

  background-image: url("/background/WavesUp.svg");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: inherit;

  min-height: 600px;
`;

export const EmptyInnerWrapper = styled.div`
  width: 100%;
  max-width: 1100px;
  padding: 0 24px;
`;

export const EmptyInfoWrapper = styled.div`
  margin-bottom: 20px;

  @media ${device.tablet} {
    margin-bottom: 60px;
  }

  @media ${device.laptop} {
    margin-bottom: 100px;
  }
`;

export const EmptyTitle = styled.div`
  font-family: ${typography.fontFamily};
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 32px;
  color: ${colors.white};

  @media ${device.laptop} {
    font-size: 36px;
    line-height: 44px;
  }
`;

export const EmptyText = styled.div`
  font-family: ${typography.fontFamily};
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 20px;
  color: ${colors.mainLight};

  @media ${device.laptop} {
    font-size: 20px;
    line-height: 28px;
  }
`;

export const EmptyPaperPlaneWrapper = styled.div`
  display: none;

  @media ${device.tablet} {
    display: block;
    position: absolute;
    bottom: 20px;
    right: 0;
  }
`;

export const MobileViewMapButton = styled.div`
  display: flex;
  align-items: center;
  padding: 10px 25px;

  z-index: 100;
  position: fixed;
  bottom: 40px;
  left: 50%;
  transform: translateX(-50%);

  background: ${colors.grey};
  border-radius: 8px;

  @media ${device.tablet} {
    display: none;
  }
`;

export const MobileViewMapButtonText = styled.p`
  font-family: ${typography.fontFamily};
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0;
  text-align: center;
  color: ${colors.white};
  margin-left: 15px;
`;

export const InputWrapper = styled.div`
  position: relative;
  margin-bottom: 40px;

  button {
    display: none;

    @media ${device.tablet} {
      display: block;
    }
  }
`;

export const SearchIconWrapper = styled.div`
  display: flex;
  margin: 0 10px 0 5px;
`;
export const NumberFilterContainer = styled.div`
  display: block;
  position: absolute;
  width: 28px;
  height: 28px;
  top: -12px;
  right: -12px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${colors.main};
  border-radius: 200px;

  font-family: ${typography.fontFamily};
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  color: ${colors.white};
`;
